import PanelHeader from './PanelHeader.jsx';

export default PanelHeader;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FullScreenPanel/PanelHeader/index.js